import currencyLib from "currency.js";
import { useAppSelector } from "../../../services/hooks/useReduxHooks";
import { useTranslationI18 } from "../../../services/hooks/useTranslationI18";
import {
  isArabicLanguage,
  localizedNumber,
} from "../../../utils/help/localization/localization";
import { ItemType, RestaurantTypeEnum } from "../../../utils/types";

export const DiscountedPrice = (props: {
  item: ItemType;
  isValidOffer: boolean;
  subItemIndex?: number;
}) => {
  const { t } = useTranslationI18();
  const currency = useAppSelector((state) => state.config.currency);
  const isLanguageArabic = isArabicLanguage();

  const { item, isValidOffer, subItemIndex } = props;

  const returnedPrice = (price: number) => {
    return (
      <div
        style={
          isLanguageArabic
            ? { display: "flex", flexDirection: "row-reverse", gap: "0.5rem" }
            : {}
        }
      >
        <span data-testid="item_price">{Boolean(price) && currency}</span>
        <span>
          {price ? localizedNumber(price) : t("common:price-on-selection")}
        </span>
      </div>
    );
  };
  const ecommerce = useAppSelector(
    (state) => state.config?.restaurantInfo?.type
  );

  const isEcommerce: boolean = ecommerce === RestaurantTypeEnum.ECOMMERCE;

  return isValidOffer ? (
    <div
      style={{
        display: "flex",
        flexDirection: isEcommerce ? "row" : "column",
        gap: isEcommerce ? "16px" : "0px",
      }}
    >
      <del style={{ color: "#D8D8D8" }}>
        {returnedPrice(
          currencyLib(item.subItems[subItemIndex || 0].previousPrice).value
        )}
      </del>
      <span>
        {returnedPrice(
          currencyLib(item.subItems[subItemIndex || 0].price).value
        )}
      </span>
    </div>
  ) : (
    <>
      <span data-testid={`item_price-${item.subItems[subItemIndex || 0].name}`}>
        {returnedPrice(
          currencyLib(item.subItems[subItemIndex || 0].price).value
        )}
      </span>
    </>
  );
};
